module.exports = __webpack_public_path__ + "img/_0.85479de6.png";